import SvgIcon from '@/components/common/svg-icon.vue'; // svg component
import { i18n, install } from '@/i18n';
import { initReport, rem, request, vueTap } from '@tencent/ppd-base-libs';
import { setRequest } from '@tencent/wphk-act-base-cgi';
import { setServerTime } from '@tencent/wphk-components-common/utils/server-time';
import VueCompositionAPI from '@vue/composition-api';
import { axios } from '@tencent/wphk-base-request';
import { createPinia, PiniaVuePlugin } from 'pinia';
import Vue from 'vue';
import Router from 'vue-router';
import App from './App.vue';
import routerInfo from './router';
import { thousands } from './utils';
import { getServerTime } from './utils/date-helper';

import { plugin } from '@tencent/fit-bi-sdk';
import mtaGlobalConfig from '@/mta-config-global';

import { setUpWeixin } from './utils/setup-wx';
import { aegis } from '@tencent/wphk-base-report';
import { getActBaseConfig } from './config';
// 登录态处理
import '@/utils/login';

aegis.init({ id: 'good-deed-day' });

// 多语言
Vue.use(install);
// 数字处理
Vue.prototype.$thousands = thousands;
// 处理路由信息
Vue.use(Router);
const router = new Router(routerInfo);
router.beforeEach((to, from, next) => {
  // 修改标题
  if (to.name === 'donation') {
    document.title = i18n('我的捐贈');
  } else {
    document.title = i18n('日行一善');
  }
  next();
});

Vue.use(plugin, {
  // 用到mtaGlobalConf里的cid/sid/group/project/projectDesc属性
  ...mtaGlobalConfig,
  route: router,
});

// 设置系统时间
const win: any = window;
const serverTime = win.__$$_serverTimeMills ? new Date(win.__$$_serverTimeMills) : new Date();
setServerTime(serverTime.getTime());
console.log('读取服务器时间：', getServerTime().toDateString());

// 将配置定义为全局变量
Vue.prototype.$ActBaseConf = getActBaseConfig();

// register globally
Vue.component('SvgIcon', SvgIcon);
const req = require.context('@/assets/icons/svg', false, /\.svg$/); // params：文件夹，是否使用子文件夹，文件匹配正则
req.keys().map((ele) => req(ele));
const requireAll = (requireContext) => requireContext.keys().map(requireContext);
requireAll(req);

// 注册组合式API和pinia
Vue.use(VueCompositionAPI);
Vue.use(PiniaVuePlugin);
const pinia = createPinia();

request.init(axios);
setRequest(request);

// 上报
initReport(
  {
    router,
    // @ts-ignore
    appEnv: process.env.VUE_APP_ENV,
    // @ts-ignore
    business: process.env.VUE_APP_PKGNAME, // 区分业务，用于elk
    isReportPageStayedTime: true, // 是否上报页面停留时间
    sentry: {
      dsn: 'https://c05e48ef096e447b8b601663d1e542d0@report.url.cn/sentry/3929',
      // webpack变异全局变量
      release: process.env.VUE_APP_SENTRY_VERSION,
    },
    bi: {
      reportNeedLogin: true,
    },
  },
  Vue,
);

// 开启rem布局
rem();
// 开启vtap
Vue.use(vueTap);
Vue.config.ignoredElements = ['wx-open-launch-weapp', 'wx-open-subscribe'];// 微信sdk初始化
setUpWeixin();

Vue.config.productionTip = false;

new Vue({
  pinia,
  router,
  render: (h) => h(App),
}).$mount('#app');

aegis.reportTime('main_ready');
